import { Snackbar, Alert } from '@mui/material'

interface NotificationSnackbarsProps {
  errorMessage?: string
  setErrorMessage?: (message: string) => void
  successMessage?: string
  setSuccessMessage?: (message: string) => void
}

export let NotificationSnackbars = ({
  errorMessage,
  setErrorMessage,
  successMessage,
  setSuccessMessage,
}: NotificationSnackbarsProps) => (
  <>
    {errorMessage !== undefined && setErrorMessage && (
      <Snackbar
        open={!!errorMessage}
        onClose={() => setErrorMessage('')}
        autoHideDuration={6000}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert
          variant="filled"
          onClose={() => setErrorMessage('')}
          severity="error"
          role="alert"
          aria-live="assertive"
        >
          <strong>Error: </strong>
          {errorMessage}
        </Alert>
      </Snackbar>
    )}

    {successMessage !== undefined && setSuccessMessage && (
      <Snackbar
        open={!!successMessage}
        onClose={() => setSuccessMessage('')}
        autoHideDuration={6000}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert
          variant="filled"
          onClose={() => setSuccessMessage('')}
          severity="success"
          role="alert"
          aria-live="polite"
        >
          {successMessage}
        </Alert>
      </Snackbar>
    )}
  </>
)
